import {FC, useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {SettingReferenceParamsModel} from '../models/SettingReferenceParamsModel'
import {SimpleListModel} from '../../../shared/models/SimpleListModel'
import {SettingReferenceStatus} from '../constants'
import {
  selectServicesList,
  selectSettingReferenceFilter,
  getAllServices,
  filterDataChange,
} from '../redux/SettingReferenceRedux'
type Props = {
  className?: string
}
const SettingReferenceFilter: FC<Props> = (props) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const didRequest = useRef(false)
  const history = useHistory()
  const filter: SettingReferenceParamsModel = useAppSelector(selectSettingReferenceFilter)
  const serviceList: SimpleListModel[] = useAppSelector(selectServicesList)
  const isActiveStatus = filter.status !== SettingReferenceStatus.DISABLE

  const handleFilterChange = (filterData: any) => {
    //auto reset paging to first page when filtering
    dispatch(filterDataChange({...filter, ...filterData, ...{page: 1}}))
  }
  useEffect(() => {
    try {
      if (!didRequest.current) {
        dispatch(getAllServices(false))
      }
    } catch (error: any) {
      toast.error(intl.formatMessage({id: 'SERVER.' + error.message}))
    }

    didRequest.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (serviceList.length > 0 && !filter.serviceId) {
      const defaultServiceId = String(serviceList[0].id)
      handleFilterChange({serviceId: defaultServiceId, categoryId: undefined})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceList, filter.serviceId])

  const handleServiceChange = (serviceId: string | undefined) => {
    if (serviceId !== filter.serviceId) {
      handleFilterChange({serviceId, categoryId: undefined})
    }
  }

  const handleStatusToggle = (isActive: boolean) => {
    const targetStatus = isActive ? SettingReferenceStatus.ACTIVE : SettingReferenceStatus.DISABLE
    if (filter.status !== targetStatus) {
      handleFilterChange({status: targetStatus})
    }
  }
  return (
    <>
      <div className='card-title'>
        <div className='d-flex align-items-center position-relative my-1'>
          <i className='bi bi-search fs-1 position-absolute ms-6'></i>
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={intl.formatMessage({id: 'SETTING_REFERENCE.BTN.SEARCH'})}
            value={filter.name}
            onChange={(e) => {
              if (e.target.value.length === 0) {
                handleFilterChange({name: undefined})
              } else if (e.target.value.length >= 2) {
                handleFilterChange({name: e.target.value})
              }
            }}
          />
        </div>
      </div>
      <div className='card-toolbar'>
        <div className='d-flex flex-wrap justify-content-end align-items-center gap-4'>
          <div className='d-flex flex-wrap align-items-end gap-4'>
            <div className='d-flex align-items-center gap-2'>
              <label className='form-label fs-6 fw-bold mb-0 text-nowrap'>
                {intl.formatMessage({id: 'SETTING_REFERENCE.FILTER.SERVICE'})}:
              </label>
              <select
                className='form-select form-select-solid fw-bolder'
                data-hide-search='true'
                value={filter.serviceId ?? ''}
                onChange={(e) => {
                  const value = e.target.value.length === 0 ? undefined : e.target.value
                  handleServiceChange(value)
                }}
              >
                {serviceList?.map((service: any) => {
                  const serviceValue = String(service.id)
                  return (
                    <option key={serviceValue} value={serviceValue}>
                      {intl.formatMessage({id: 'SERVICE.SERVICE.' + service.label})}
                    </option>
                  )
                })}
              </select>
            </div>
            <div className='d-flex align-items-center gap-2'>
              <label className='form-label fs-6 fw-bold mb-0 text-nowrap'>
                {intl.formatMessage({id: 'SETTING_REFERENCE.TABLE.STATUS'})}:
              </label>
              <div className='form-check form-check-solid form-switch mb-0 py-2'>
                <input
                  className='form-check-input '
                  type='checkbox'
                  id='setting-status-toggle'
                  checked={isActiveStatus}
                  onChange={(e) => handleStatusToggle(e.target.checked)}
                />
                <label
                  className='form-check-label fw-bold text-gray-700'
                  htmlFor='setting-status-toggle'
                >
                  {isActiveStatus ? intl.formatMessage({id: 'SETTING_REFERENCE.STATUS.ACTIVE'}) : intl.formatMessage({id: 'SETTING_REFERENCE.STATUS.DEACTIVATE'})}
                </label>
              </div>
            </div>
          </div>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              history.push('/setting-references/create')
            }}
          >
            <i className='bi bi-plus-circle-fill fs-2'></i>
            {intl.formatMessage({id: 'SETTING_REFERENCE.BTN.ADD_NEW'})}
          </button>
        </div>
      </div>
    </>
  )
}

export default SettingReferenceFilter
